import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
    ArrowRight,
    Check,
    GitBranch,
    RefreshCw,
    Sparkles,
    Trash2,
    Zap,
} from "lucide-react";
import { toast } from "sonner";
import { whatsappMerkez } from "@/lib/api";
import { Button } from "@/components/ui/button";

const LIFECYCLE_TOGGLES = [
    [
        "lifecycle_durum_degisim",
        "Durum değişiminde otomatik WhatsApp",
        "Sigorta dosyası durumu değişince müvekkile mesaj gider.",
    ],
    [
        "lifecycle_otomatik_onaysiz",
        "Yaşam döngüsü onaysız gönderim",
        "Tahkim, kapanış ve durum mesajları onay beklemeden Evolution ile iletilir.",
    ],
    [
        "lifecycle_akilli_yonlendirme",
        "Akıllı geçiş yönlendirme (tek mesaj)",
        "TAHKIM/KAPATILDI geçişlerinde çift mesaj engellenir; en uygun şablon seçilir.",
    ],
    [
        "lifecycle_kapanis",
        "Kapanış mesajı (dosya_kapanis şablonu)",
        "→ Kapatıldı geçişlerinde teşekkür / sonuç mesajı.",
    ],
    [
        "tetik_tahkim",
        "Tahkim mesajı (tahkim_eksper şablonu)",
        "→ Tahkime Başvuru geçişlerinde eksper raporu talebi.",
    ],
    [
        "lifecycle_eksper",
        "Eksper süreci mesajları (cron / manuel)",
        "Günlük otomasyon ve manuel tetiklemeler için.",
    ],
    [
        "lifecycle_deger_kaybi",
        "Değer kaybı hesaplandığında mesaj",
        null,
    ],
    [
        "lifecycle_vekalet",
        "Vekalet bekleniyor hatırlatması",
        null,
    ],
    [
        "lifecycle_basvuru_sure",
        "Başvuru süresi yaklaşınca WhatsApp uyarısı",
        "Sigorta cevap süresi dolmadan müvekkile otomatik hatırlatma.",
    ],
    [
        "mesai_aktif",
        "Otomatik mesaj mesai kısıtı (09:30–19:30)",
        "Açıksa otomatik WhatsApp yalnızca mesai saatleri içinde gider; gece bekletilir.",
    ],
    [
        "araci_bildirim_aktif",
        "Aracı WhatsApp bildirimleri",
        "Dosya durumu değişince müvekkile bağlı aracılara bilgi mesajı.",
    ],
    [
        "evrak_filtresi_aktif",
        "Tahkim mesajı — evrak filtresi",
        "Ruhsat + kaza fotoğrafı eksikse genel durum mesajı gönderilir.",
    ],
];

const INBOX_TOGGLES = [
    [
        "inbox_akil_otomatik",
        "Gelen kutusu Akıl otomasyonu (TC + OTP)",
        "Müvekkil dosya sorusu sorunca T.C. ister, WhatsApp OTP doğrular, dosya özetini otomatik gönderir.",
    ],
    [
        "inbox_evrak_otomatik",
        "Gelen evrak otomatik yükleme (PDF / foto)",
        "WhatsApp'tan gelen belgeler müvekkil telefonu ile eşleştirilip sigorta dosyasına evrak olarak kaydedilir.",
    ],
    [
        "inbox_evrak_otomatik_onay",
        "Güvenilir eşleşmede otomatik ONAYLI yükleme",
        "Telefon + açık dosya eşleşmesi yüksek güven puanında evrak onaylı kaydedilir; düşük puanda onay bekler.",
    ],
    [
        "inbox_evrak_yari_otomatik",
        "Yarı otomatik evrak — panel onay kuyruğu",
        "Düşük güven veya belirsiz eşleşmeler onay çekmecesine düşer; yüksek güven otomatik yüklenir.",
    ],
    [
        "inbox_evrak_ocr_dogrula",
        "OCR ile plaka / T.C. doğrulama",
        "Belge metninden plaka ve kimlik numarası okunarak doğru dosya ve müvekkil seçilir.",
    ],
    [
        "inbox_evrak_mukerrer_engelle",
        "Mükerrer belge engeli (48 saat)",
        "Aynı dosyaya aynı belge tekrar yüklenmez.",
    ],
    [
        "inbox_evrak_bildirim_gonder",
        "Onaylı evrak WhatsApp teşekkür mesajı",
        "Otomatik onaylanan evrak için müvekkile kısa bilgilendirme gider.",
    ],
    [
        "inbox_evrak_grup_kabul",
        "Grup mesajlarından evrak kabul",
        "Kapalıyken yalnızca birebir sohbetlerdeki medya evrak olarak işlenir.",
    ],
    [
        "inbox_evrak_video_kabul",
        "Video dosyalarını evrak olarak kabul et",
        "Kapalıyken yalnızca PDF ve fotoğraf işlenir.",
    ],
];

const GENERAL_TOGGLES = [
    ["global_whatsapp_aktif", "Tüm WhatsApp Gönderimleri AKTİF", "Kapatılırsa sistemden hiçbir WhatsApp mesajı gitmez."],
    ["test_modu_aktif", "Sadece Test Numarasına Gönder (Güvenli Mod)", "Açılırsa sadece test telefonuna gönderim yapılır, diğer numaralar engellenir."],
    ["onay_modu", "Onay modu (kampanya / zincir mesajları)", "Yaşam döngüsü mesajları bundan etkilenmez."],
    ["otomatik_gonderim", "Evolution API ile otomatik gönder", null],
    ["cron_aktif", "Günlük otomasyon (09:00 cron)", null],
    ["zincir_aktif", "3 aşamalı mesaj zinciri (gün 12 / 15 / 16+)", null],
    ["otomatik_tahkim_gecis", "Süre dolunca otomatik ön tahkime geç", "Sompo 20 / diğer 15 gün sonunda BASVURU → ON_TAHKIM. STK tahkim (TAHKIM) her zaman panelden manuel onay ister."],
    ["sms_yedek_aktif", "WhatsApp başarısızsa Netgsm SMS yedek", null],
    ["hatirlatma_aktif", "7 gün cevap yoksa hatırlatma (max 2)", null],
    ["tetik_yeni_muvekkil", "Yeni müvekkil hoşgeldin mesajı", null],
    ["tetik_yatar_onay", "Yeni müvekkilde yatar dosyası yasal onay mesajı", "Kayıt sonrası EVET/HAYIR ile yasal bilgilendirme ve onay toplanır."],
    ["eski_sigorta_whatsapp_kapat", "Eski genel sigorta WhatsApp mesajını kapat", null],
    ["evrak_modul_aktif", "Evrak hatırlatma modülü", null],
];

/** API'den gelmeyen alanlar için model varsayılanları */
const TOGGLE_DEFAULTS = {
    global_whatsapp_aktif: true,
    test_modu_aktif: false,
    otomatik_gonderim: false,
    onay_modu: true,
    cron_aktif: true,
    zincir_aktif: true,
    otomatik_tahkim_gecis: true,
    sms_yedek_aktif: false,
    hatirlatma_aktif: true,
    tetik_yeni_muvekkil: true,
    tetik_yatar_onay: true,
    eski_sigorta_whatsapp_kapat: true,
    evrak_modul_aktif: true,
    lifecycle_durum_degisim: true,
    lifecycle_otomatik_onaysiz: true,
    lifecycle_akilli_yonlendirme: true,
    lifecycle_kapanis: true,
    tetik_tahkim: true,
    lifecycle_eksper: true,
    lifecycle_deger_kaybi: true,
    lifecycle_vekalet: true,
    lifecycle_basvuru_sure: true,
    mesai_aktif: true,
    araci_bildirim_aktif: true,
    evrak_filtresi_aktif: true,
    inbox_akil_otomatik: true,
    inbox_evrak_otomatik: false,
    inbox_evrak_otomatik_onay: true,
    inbox_evrak_yari_otomatik: true,
    inbox_evrak_ocr_dogrula: true,
    inbox_evrak_mukerrer_engelle: true,
    inbox_evrak_bildirim_gonder: true,
    inbox_evrak_grup_kabul: false,
    inbox_evrak_video_kabul: false,
};

const ALL_TOGGLE_GROUPS = [
    { id: "lifecycle", title: "Yaşam döngüsü", items: LIFECYCLE_TOGGLES },
    { id: "inbox", title: "Gelen kutusu", items: INBOX_TOGGLES },
    { id: "general", title: "Genel otomasyon", items: GENERAL_TOGGLES },
];

function isToggleOn(ayarlar, field) {
    if (!ayarlar) return false;
    const raw = ayarlar[field];
    if (raw === undefined || raw === null) {
        return TOGGLE_DEFAULTS[field] ?? false;
    }
    return !!raw;
}

function StatusBadge({ on, compact }) {
    return (
        <span
            className={`inline-flex items-center gap-1 font-semibold uppercase tracking-wider ${
                compact ? "text-[9px]" : "text-[10px]"
            } ${on ? "text-[#25d366]" : "text-[#8b93ae]"}`}
        >
            {on ? (
                <>
                    <Check className={compact ? "h-2.5 w-2.5" : "h-3 w-3"} strokeWidth={3} />
                    Açık
                </>
            ) : (
                <>Kapalı</>
            )}
        </span>
    );
}

function ToggleRow({ field, label, hint, ayarlar, setAyarlar, accent }) {
    const on = isToggleOn(ayarlar, field);

    return (
        <label
            className={`flex flex-col gap-2 text-sm cursor-pointer rounded-lg border px-3 py-2.5 transition-colors ${
                on
                    ? accent
                        ? "border-[rgba(37,211,102,0.45)] bg-[rgba(37,211,102,0.1)]"
                        : "border-emerald-500/30 bg-emerald-500/[0.06]"
                    : accent
                      ? "border-white/10 bg-black/10 hover:border-white/20"
                      : "border-white/10 bg-black/10 hover:border-white/20 opacity-90"
            }`}
        >
            <span className="flex items-start gap-3">
                <span
                    className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded border transition-colors ${
                        on
                            ? "border-[#25d366] bg-[#25d366] text-[#0b1437]"
                            : "border-white/25 bg-black/20 text-transparent"
                    }`}
                    aria-hidden="true"
                >
                    {on ? <Check className="h-3.5 w-3.5" strokeWidth={3} /> : null}
                </span>
                <input
                    type="checkbox"
                    checked={on}
                    onChange={(e) => setAyarlar((p) => ({ ...p, [field]: e.target.checked }))}
                    className="sr-only"
                />
                <span className="min-w-0 flex-1">
                    <span className="text-[#d6dbe8] block">{label}</span>
                    {hint && <span className="text-[10px] text-[#8b93ae] block mt-0.5">{hint}</span>}
                </span>
            </span>
            <span className="pl-8">
                <StatusBadge on={on} />
            </span>
        </label>
    );
}

function ModuleStatusOverview({ ayarlar }) {
    const rows = useMemo(() => {
        return ALL_TOGGLE_GROUPS.flatMap((group) =>
            group.items.map(([key, label]) => ({
                group: group.title,
                key,
                label,
                on: isToggleOn(ayarlar, key),
            }))
        );
    }, [ayarlar]);

    const acik = rows.filter((r) => r.on).length;
    const kapali = rows.length - acik;

    return (
        <section className="rounded-xl border border-white/10 bg-[#0b1437]/90 p-5 space-y-4">
            <div className="flex flex-wrap items-end justify-between gap-3">
                <div>
                    <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#8b93ae]">
                        Modül durumu özeti
                    </p>
                    <h3 className="text-base font-display text-[#f5ecd6] mt-1">
                        {acik} açık · {kapali} kapalı
                    </h3>
                    <p className="text-xs text-[#8b93ae] mt-1">
                        Tik işaretli modüller açık; tik yoksa kapalı. Değişiklikler kaydedilene kadar yerel önizlemedir.
                    </p>
                </div>
                <div className="flex gap-2 text-xs">
                    <span className="inline-flex items-center gap-1 rounded-full border border-[#25d366]/40 bg-[#25d366]/10 px-3 py-1 text-[#25d366]">
                        <Check className="h-3 w-3" strokeWidth={3} />
                        Açık: {acik}
                    </span>
                    <span className="inline-flex items-center gap-1 rounded-full border border-white/15 bg-black/20 px-3 py-1 text-[#8b93ae]">
                        Kapalı: {kapali}
                    </span>
                </div>
            </div>

            <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3 max-h-72 overflow-y-auto pr-1">
                {rows.map((row) => (
                    <div
                        key={row.key}
                        className={`flex items-start justify-between gap-2 rounded-lg border px-3 py-2 text-xs ${
                            row.on
                                ? "border-[#25d366]/25 bg-[#25d366]/5"
                                : "border-white/8 bg-black/15"
                        }`}
                    >
                        <span className="min-w-0">
                            <span className="text-[9px] uppercase tracking-wider text-[#8b93ae] block">
                                {row.group}
                            </span>
                            <span className="text-[#d6dbe8] line-clamp-2">{row.label}</span>
                        </span>
                        <StatusBadge on={row.on} compact />
                    </div>
                ))}
            </div>
        </section>
    );
}

function SectionToggleSummary({ items, ayarlar }) {
    const acik = items.filter(([key]) => isToggleOn(ayarlar, key)).length;
    const kapali = items.length - acik;
    return (
        <p className="text-[10px] text-[#8b93ae]">
            Bu bölüm:{" "}
            <span className="text-[#25d366] font-semibold">{acik} açık</span>
            {" · "}
            <span className="text-[#8b93ae] font-semibold">{kapali} kapalı</span>
        </p>
    );
}

export default function WhatsAppLifecycleSettings({ ayarlar, setAyarlar, onSaved }) {
    const [gecisler, setGecisler] = useState([]);
    const [loadingGecis, setLoadingGecis] = useState(true);
    const [cleanupBusy, setCleanupBusy] = useState(false);

    const loadGecisler = useCallback(async () => {
        setLoadingGecis(true);
        try {
            const data = await whatsappMerkez.durumGecisleri();
            setGecisler(data.gecisler || []);
        } catch {
            toast.error("Geçiş matrisi yüklenemedi.");
        } finally {
            setLoadingGecis(false);
        }
    }, []);

    useEffect(() => {
        loadGecisler();
    }, [loadGecisler]);

    const runCleanup = async (dryRun = false) => {
        setCleanupBusy(true);
        try {
            const stats = await whatsappMerkez.lifecycleCleanup(dryRun);
            if (dryRun) {
                toast.info(
                    `Önizleme: ${stats.iptal} iptal, ${stats.gonderildi_kuyruk} gönderilecek, ${stats.atlandi} atlandı`
                );
            } else {
                toast.success(
                    `Temizlik tamam: ${stats.iptal} iptal, ${stats.gonderildi_kuyruk} kuyruğa alındı`
                );
                onSaved?.();
            }
        } catch {
            toast.error("Yaşam döngüsü temizliği başarısız.");
        } finally {
            setCleanupBusy(false);
        }
    };

    if (!ayarlar) return null;

    return (
        <div className="space-y-6 max-w-4xl">
            <ModuleStatusOverview ayarlar={ayarlar} />

            <section className="rounded-xl border border-[rgba(37,211,102,0.3)] bg-gradient-to-br from-[#0d2818]/40 via-[#0b1437]/90 to-[#111c4a]/80 p-5 space-y-4">
                <div className="flex items-start justify-between gap-4 flex-wrap">
                    <div>
                        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#25d366] flex items-center gap-1.5">
                            <Sparkles className="h-3.5 w-3.5" />
                            Ultra Yaşam Döngüsü Otomasyonu
                        </p>
                        <h3 className="text-base font-display text-[#f5ecd6] mt-1">
                            Durum değişince tek mesaj, onaysız gönderim
                        </h3>
                        <p className="text-xs text-[#8b93ae] mt-1 max-w-xl">
                            Sigorta dosyası modülünde Yeni → Başvuru → Tahkim → Kapatıldı geçişlerinde
                            müvekkile otomatik WhatsApp gider. Onay kuyruğu atlanır; çift mesaj engellenir.
                        </p>
                    </div>
                    <div className="flex gap-2 flex-wrap">
                        <Button
                            size="sm"
                            variant="outline"
                            disabled={cleanupBusy}
                            onClick={() => runCleanup(true)}
                            className="border-white/15 text-xs"
                        >
                            <RefreshCw className="h-3.5 w-3.5 mr-1" />
                            Önizle
                        </Button>
                        <Button
                            size="sm"
                            disabled={cleanupBusy}
                            onClick={() => runCleanup(false)}
                            className="bg-[#25d366]/20 text-[#25d366] border border-[#25d366]/40 hover:bg-[#25d366]/30 text-xs"
                        >
                            <Trash2 className="h-3.5 w-3.5 mr-1" />
                            Bekleyenleri temizle
                        </Button>
                    </div>
                </div>

                <SectionToggleSummary items={LIFECYCLE_TOGGLES} ayarlar={ayarlar} />

                <div className="grid gap-2 sm:grid-cols-2">
                    {LIFECYCLE_TOGGLES.map(([key, label, hint]) => (
                        <ToggleRow
                            key={key}
                            field={key}
                            label={label}
                            hint={hint}
                            ayarlar={ayarlar}
                            setAyarlar={setAyarlar}
                            accent
                        />
                    ))}
                </div>
            </section>

            <section className="rounded-xl border border-violet-500/25 bg-[#111c4a]/60 p-5 space-y-3">
                <h3 className="flex items-center gap-2 text-sm font-semibold text-violet-200">
                    <Sparkles className="h-4 w-4" />
                    Gelen kutusu otomasyonu
                </h3>
                <p className="text-xs text-[#8b93ae]">
                    Akıl botu (TC/OTP) ve gelen evrakların otomatik dosyaya yüklenmesi.
                </p>
                <SectionToggleSummary items={INBOX_TOGGLES} ayarlar={ayarlar} />
                <div className="grid gap-2">
                    {INBOX_TOGGLES.map(([key, label, hint]) => (
                        <ToggleRow
                            key={key}
                            field={key}
                            label={label}
                            hint={hint}
                            ayarlar={ayarlar}
                            setAyarlar={setAyarlar}
                        />
                    ))}
                </div>
                <div className="grid gap-3 sm:grid-cols-2 pt-2 border-t border-white/10">
                    <label className="text-xs text-[#8b93ae] space-y-1">
                        <span className="block text-[#d6dbe8]">Minimum güven puanı (yükleme)</span>
                        <input
                            type="number"
                            min={0}
                            max={100}
                            value={ayarlar.inbox_evrak_guven_min ?? 55}
                            onChange={(e) =>
                                setAyarlar((p) => ({
                                    ...p,
                                    inbox_evrak_guven_min: Number(e.target.value),
                                }))
                            }
                            className="w-full rounded-md border border-white/15 bg-black/30 px-2 py-1.5 text-sm text-white"
                        />
                        <span className="text-[10px]">Bu puanın altında evrak yüklenmez.</span>
                    </label>
                    <label className="text-xs text-[#8b93ae] space-y-1">
                        <span className="block text-[#d6dbe8]">Otomatik onay eşiği</span>
                        <input
                            type="number"
                            min={0}
                            max={100}
                            value={ayarlar.inbox_evrak_onay_esigi ?? 75}
                            onChange={(e) =>
                                setAyarlar((p) => ({
                                    ...p,
                                    inbox_evrak_onay_esigi: Number(e.target.value),
                                }))
                            }
                            className="w-full rounded-md border border-white/15 bg-black/30 px-2 py-1.5 text-sm text-white"
                        />
                        <span className="text-[10px]">Telefon eşleşmesi + bu puan → ONAYLI evrak.</span>
                    </label>
                </div>
            </section>

            <section className="rounded-xl border border-white/10 bg-[#0b1437]/80 p-5 space-y-3">
                <h3 className="flex items-center gap-2 text-sm font-semibold text-[#e6cf94]">
                    <GitBranch className="h-4 w-4" />
                    Durum geçiş matrisi
                </h3>
                <p className="text-xs text-[#8b93ae]">
                    Her geçişte yalnızca bir şablon seçilir — müvekkil tek mesaj alır.
                </p>
                {loadingGecis ? (
                    <p className="text-xs text-[#8b93ae]">Yükleniyor…</p>
                ) : (
                    <div className="overflow-x-auto rounded-lg border border-white/10">
                        <table className="w-full text-xs">
                            <thead>
                                <tr className="border-b border-white/10 text-[#8b93ae] text-left">
                                    <th className="px-3 py-2 font-medium">Eski durum</th>
                                    <th className="px-2 py-2 w-8" />
                                    <th className="px-3 py-2 font-medium">Yeni durum</th>
                                    <th className="px-3 py-2 font-medium">Şablon</th>
                                    <th className="px-3 py-2 font-medium hidden md:table-cell">Açıklama</th>
                                </tr>
                            </thead>
                            <tbody>
                                {gecisler.map((g) => (
                                    <tr
                                        key={`${g.onceki_durum}-${g.yeni_durum}`}
                                        className="border-b border-white/5 hover:bg-white/[0.03]"
                                    >
                                        <td className="px-3 py-2 text-[#d6dbe8]">{g.onceki_label}</td>
                                        <td className="px-2 py-2 text-[#25d366]">
                                            <ArrowRight className="h-3.5 w-3.5" />
                                        </td>
                                        <td className="px-3 py-2 text-[#f5ecd6]">{g.yeni_label}</td>
                                        <td className="px-3 py-2">
                                            <code className="text-[10px] text-[#7dd3fc] bg-black/30 px-1.5 py-0.5 rounded">
                                                {g.sablon_kod}
                                            </code>
                                        </td>
                                        <td className="px-3 py-2 text-[#8b93ae] hidden md:table-cell max-w-xs truncate">
                                            {g.aciklama || "—"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </section>

            <section className="rounded-xl border border-white/10 bg-[#0b1437]/80 p-5 space-y-3">
                <h3 className="flex items-center gap-2 text-sm font-semibold text-[#e6cf94]">
                    <Zap className="h-4 w-4" />
                    Genel otomasyon
                </h3>
                <SectionToggleSummary items={GENERAL_TOGGLES} ayarlar={ayarlar} />
                <div className="grid gap-2 sm:grid-cols-2">
                    {GENERAL_TOGGLES.map(([key, label, hint]) => (
                        <ToggleRow
                            key={key}
                            field={key}
                            label={label}
                            hint={hint}
                            ayarlar={ayarlar}
                            setAyarlar={setAyarlar}
                        />
                    ))}
                </div>
            </section>
        </div>
    );
}
